import type { PaymentTableData } from './types';

export const PAYMENT_OPTIONS = [
  {
    label: '信用卡',
    value: 'creditCard',
  },
  {
    label: '點數',
    value: 'point',
  },
];

export const PAYMENT_TABLE_DATASOURCE: PaymentTableData[] = [
  {
    id: 'memberRow',
    isMember: true,
    price: null,
    point: null,
    limit: null,
  },
  {
    id: 'nonMemberRow',
    isMember: false,
    price: null,
    point: null,
    limit: null,
  },
];
